export const addToFavoritesCategoryTextWithCategoryName = "HUVDN";
export const removeFromFavoritesCategoryTextWithCategoryName = "h694Ab";
export default {addToFavoritesCategoryTextWithCategoryName,removeFromFavoritesCategoryTextWithCategoryName};